export default __webpack_public_path__ + "static/media/scalable.eb6e48b5.svg";